<script setup>
import ListingTable from '@/components/dashboard/ListingTable.vue'
import InternalListingModal from '@/components/Listing/InternalListingModal.vue'
import { useUserDisplayName } from '@/composables/useUserDisplayName'
import { usePageTitle } from '@/composables/usePageTitle'
import { computed, ref } from 'vue'

definePage({
  meta: {
    layout: 'default',
    requiresAuth: true,
    roles: ['secretary_anesthetist'],
  },
})

const userName = useUserDisplayName('Anaesthetist secretary')

const pageTitle = computed(() => `Listings for your group, ${userName.value}`)

usePageTitle(pageTitle)

const showInternalModal = ref(false)
const editingInternalListing = ref(null)
const listingTableKey = ref(0)

// Filtri predefiniti: da oggi in poi, Open + Assigned
const getTodayDate = () => new Date().toISOString().split('T')[0]

const defaultContextFilters = {
  statuses: ['open_public', 'open_private', 'open_internal', 'matching', 'assigned'],
  scheduledFrom: getTodayDate(),
}

const onListingCreated = () => {
  // Force re-mount of table to refresh data
  listingTableKey.value++
  editingInternalListing.value = null
}

const onEditListing = listing => {
  editingInternalListing.value = listing
  showInternalModal.value = true
}
</script>

<template>
  <div class="secretary-anaesthetist-listings-page">
    <div class="mb-4 d-flex justify-end">
      <VBtn
        color="primary"
        variant="flat"
        prepend-icon="mdi-calendar-plus-outline"
        @click="showInternalModal = true"
      >
        New Internal Listing
      </VBtn>
    </div>

    <ListingTable
      :key="listingTableKey"
      title="All listings"
      store-id="secretary-anaesthetist-listings"
      endpoint="/api/secretary-anesthetists/listings"
      role-context="secretary_anaesthetist"
      :hide-filter-fields="['statuses']"
      :context-filters="defaultContextFilters"
      :lock-context-filters="false"
      :auto-apply-on-mount="true"
      @edit-listing="onEditListing"
    />

    <InternalListingModal
      v-model="showInternalModal"
      :editing-listing="editingInternalListing"
      @created="onListingCreated"
    />
  </div>
</template>

<style scoped>
.secretary-anaesthetist-listings-page {
  padding-block: 0.5rem 0;
}
</style>
